import React, { useState, useEffect } from 'react';

import { ModalCodeSuccess, ChangePassword } from './codeSuccess.styles';

export default function CodeSuccess(props) {
  const [codeSuccess, setCodeSuccess] = useState(props.showModalCodeSuccess);

  useEffect(() => {
    setCodeSuccess(props.showModalCodeSuccess);
  }, [props.showModalCodeSuccess]);

  const closeModal = () => setCodeSuccess(false);

  return (
    <ModalCodeSuccess showModalCodeSuccess={codeSuccess}>
      <div>
        <div>
          <h3>Código enviado</h3>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
        </div>
        <ChangePassword>
          <p>
            Ingresa el código para establecer tu nueva contraseña en <span>FinSphera</span>
          </p>
          <button onClick={closeModal}>Cerrar</button>
        </ChangePassword>
      </div>
    </ModalCodeSuccess>
  );
}
